module.exports = __webpack_public_path__ + "img/glassthicknessplus-167.26855eb5.svg";